import React, { useState, useEffect } from "react";
import { useLocation, useSearchParams } from 'react-router-dom';
import { gapi } from 'gapi-script';
import Header from "../components/header"
import Sidebar from "../components/sidebar"
import Gallery from "../components/gallery"
import Instance from "../components/instance"
import Modals from "../components/modal"
import ContactUs from "../components/contactUs"
import { Padding } from "@mui/icons-material";

const containerStyles = {
  display: "flex",
  position: "relative"
}

const App = () => {
  const [inputValue, setInputValue] = useState('')
  const [data, setData] = useState();
  const [layouts, setLayouts] = useState();
  const [placements, setPlacements] = useState();
  const [features, setFeatures] = useState();
  const [industries, setIndustries] = useState();
  const [devices, setDevices] = useState();
  const [performances, setPerformances] = useState();
  const [deliverySystems, setDeliverySystems] = useState();
  const [layoutsFilter, setLayoutsFilter] = useState();
  const [placementsFilter, setPlacementsFilter] = useState([]);
  const [featuresFilter, setFeaturesFilter] = useState();
  const [industriesFilter, setIndustriesFilter] = useState([]);
  const [devicesFilter, setDevicesFilter] = useState();
  const [performancesFilter, setPerformancesFilter] = useState();
  const [deliverySystemsFilter, setDeliverySystemsFilter] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const initClient = async () => {
    await gapi.client.init({
      'apiKey': 'AIzaSyDEt_y6KrtFoa876tecRNQFnLgrdsDaPKE',
      'scope': 'https://www.googleapis.com/auth/spreadsheets',
      'discoveryDocs': ['https://sheets.googleapis.com/$discovery/rest?version=v4']
    })
    const spreadsheetId = process.env.REACT_APP_SPREAD_SHEET_ID;
    let response = await gapi.client.sheets.spreadsheets.values.get({ spreadsheetId: spreadsheetId, range: '廣告案例' });
    let layouts = await gapi.client.sheets.spreadsheets.values.get({ spreadsheetId: spreadsheetId, range: '版型名稱' });
    let placements = await gapi.client.sheets.spreadsheets.values.get({ spreadsheetId: spreadsheetId, range: '版位' });
    let features = await gapi.client.sheets.spreadsheets.values.get({ spreadsheetId: spreadsheetId, range: '特色' });
    let industries = await gapi.client.sheets.spreadsheets.values.get({ spreadsheetId: spreadsheetId, range: '產業類別' });
    let devices = await gapi.client.sheets.spreadsheets.values.get({ spreadsheetId: spreadsheetId, range: '廣告裝置' });
    let performances = await gapi.client.sheets.spreadsheets.values.get({ spreadsheetId: spreadsheetId, range: '成效目標' });
    let deliverySystems = await gapi.client.sheets.spreadsheets.values.get({ spreadsheetId: spreadsheetId, range: '適用投遞系統' });
    response.result.values.shift();
    setData(response.result.values);
    setLayouts(layouts.result.values);
    setPlacements(placements.result.values);
    setFeatures(features.result.values);
    setIndustries(industries.result.values);
    setDevices(devices.result.values);
    setPerformances(performances.result.values);
    setDeliverySystems(deliverySystems.result.values);
  };
  useEffect(() => {
    var html = document.querySelector('html');
    html.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    gapi.load('client', initClient);
    if (navigator.language.includes('zh')) {
      setSearchParams()
    } else {
      setSearchParams({ lang: "en" })
    }
  }, []);
  const getInputValue = (value) => {
    setInputValue(value)
  }
  const getRatioValue = (objectValue) => {
    const value = Object.keys(objectValue);
    setLayoutsFilter(getArrEqual(value, getArrKey(layouts)));
    setPlacementsFilter(getArrEqual(value, getArrKey(placements)));
    setFeaturesFilter(getArrEqual(value, getArrKey(features)));
    setIndustriesFilter(getArrEqual(value, getArrKey(industries)));
    setDevicesFilter(getArrEqual(value, getArrKey(devices)));
    setPerformancesFilter(getArrEqual(value, getArrKey(performances)));
    setDeliverySystemsFilter(getArrEqual(value, getArrKey(deliverySystems)));
  }
  const getArrKey = (arr) => {
    const newArr = [];
    arr.forEach((arr) => {
      newArr.push(arr[0])
    })
    return newArr;
  }
  const getArrEqual = (arr1, arr2) => {
    let newArr = [];
    for (let i = 0; i < arr2.length; i++) {
      for (let j = 0; j < arr1.length; j++) {
        if (arr1[j] === arr2[i]) {
          newArr.push(arr1[j]);
        }
      }
    }
    return newArr;
  }
  const changeSearchParams = (parm) => {
    switch (parm) {
      case 'en':
        setSearchParams({ lang: "en" })
        break
      default:
        setSearchParams()
    }
  }
  const footerStyle = {
    height: '30px',
    width: '100vw',
    background: '#B3B3B3',
    bottom: '0',
    position: 'fixed',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '15px',
    fontSize: '14px',
    zIndex: '10000'
  }
  return (
    <>
      <Header
        changeSearchParams={changeSearchParams}
        searchParams={searchParams}
      />
      <ContactUs
        searchParams={searchParams}
      />
      <div style={containerStyles}>
        <Sidebar
          getInputValue={getInputValue}
          getRatioValue={getRatioValue}
          placements={placements}
          features={features}
          industries={industries}
          devices={devices}
          performances={performances}
          deliverySystems={deliverySystems}
          layouts={layouts}
          searchParams={searchParams}
        />
        <Gallery
          getInputValue={getInputValue}
          inputValue={inputValue}
          data={data}
          layouts={layouts}
          industries={industries}
          features={features}
          layoutsFilter={layoutsFilter}
          placementsFilter={placementsFilter}
          featuresFilter={featuresFilter}
          industriesFilter={industriesFilter}
          devicesFilter={devicesFilter}
          performancesFilter={performancesFilter}
          deliverySystemsFilter={deliverySystemsFilter}
          searchParams={searchParams}
        />
        {
          (location?.pathname !== undefined && location.pathname.indexOf('instance') !== -1) &&
          <Instance
            data={data}
            industries={industries}
            layouts={layouts}
            searchParams={searchParams}
          />
        }
        {
          (location?.pathname !== undefined && location.pathname.indexOf('modal') !== -1) &&
          <Modals
            data={data}
            searchParams={searchParams}
            layouts={layouts}
            devices={devices}
          />
        }
      </div>
      <footer style={footerStyle} >
        TenMax @ Copyright 2023. All Rights Reserved.
      </footer>
    </>
  );
}

export default App;